'use client';

import { useBrowserPlugin } from 'features/browser-plugin/browser-plugin';

export function BrowserPlugin() {
  useBrowserPlugin();
  return null;
}
